import React from 'react';
import { Link } from 'react-router-dom';

const FractionalCTO = () => {
  return (
    <section className="bg-[#FAF8F3] py-24">
      <div className="mx-auto max-w-7xl px-4 sm:px-6 lg:px-8">
        <div className="grid gap-10 border-y border-[#17211E]/15 py-12 lg:grid-cols-[.8fr_1.2fr] lg:items-center">
          <div>
            <div className="mb-5 text-xs font-bold uppercase tracking-[0.2em] text-[#D7B77A]">
              Technology consulting
            </div>
            <h2 className="text-4xl leading-tight sm:text-5xl">
              Need Help Figuring Out the Right Technology?
            </h2>
          </div>
          <div>
            <p className="text-xl leading-relaxed text-[#17211E]/75">
              Sometimes the issue isn&apos;t fixing something that&apos;s broken.
              A business may need help deciding what to buy, what to replace,
              how different systems should work together, or whether a
              technology project makes sense. ManagedSite can help sort through
              the options and create a practical plan.
            </p>
            <Link
              to="/services/technology-consulting"
              className="home-link mt-8 inline-block"
            >
              Talk Through Your Technology Needs
            </Link>
          </div>
        </div>
      </div>
    </section>
  );
};

export default FractionalCTO;